module.exports = __webpack_public_path__ + "img/Halaman Server-Error.6027d46d.png";